import { type SmartLinkResponse } from '@atlaskit/linking-types';
import {
	isBaseEntity,
	isDesignEntity,
	isDocumentEntity,
} from '@atlaskit/linking-types/entity-types';
import { fg } from '@atlaskit/platform-feature-flags';

import { extractEntity } from './extract-entity';

export const extractEntityIcon = (
	response?: SmartLinkResponse,
):
	| {
			label: string | undefined;
			url: string | undefined;
	  }
	| undefined => {
	if (fg('platform_lp_use_entity_icon_url_for_icon')) {
		const entity = extractEntity(response);
		if (!entity) {
			return undefined;
		}

		if (!isBaseEntity(entity)) {
			return undefined;
		}

		if (isDesignEntity(entity) && entity.iconUrl) {
			return {
				url: entity.iconUrl,
				label: entity.type,
			};
		}

		if (isDocumentEntity(entity) && entity.type.iconUrl) {
			return {
				url: entity.type.iconUrl,
				label: entity.type.category,
			};
		}

		// When JSON-LD is deprecated, we can change this to returning entity provider icon.
		// For now code upstream will return better result when this method returns undefined.
		return undefined;
	} else {
		const entity = extractEntity(response);

		let url: string | undefined;
		if (entity) {
			url =
				'iconUrl' in entity && typeof entity?.iconUrl === 'string'
					? entity.iconUrl
					: response?.meta.generator?.icon?.url;
		}

		return {
			url,
			label: entity?.displayName,
		};
	}
};
